const destinationSubpath = '/destinations'

export const planRoutes = [
  {
    path: `${destinationSubpath}`,
    name: 'Destinations',
    meta: { showFooter: true, showHeader: true, indexable: true },
    component: () =>
      import(
        /* webpackChunkName: "destinations" */ '@/views/destinations/Index.vue'
      )
  },
  {
    path: `${destinationSubpath}/:slug`,
    name: 'Destination',
    meta: { showFooter: true, showHeader: true, indexable: true },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "destinations" */ '@/views/destinations/Show.vue'
      )
  }
]
